// Campus photo for /colleges/illinois-state-university: CC BY-SA 3.0, by William Wesen Appraiser, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACookhall.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/illinois-state-university/; credited under the photo.
const photo = {
    "slug": "illinois-state-university",
    "alt": "Cook Hall, a gray stone building with castle-style towers, on the Illinois State University campus",
    "src": "/colleges/illinois-state-university/campus-1600.webp",
    "srcSmall": "/colleges/illinois-state-university/campus-800.webp",
    "srcMid": "/colleges/illinois-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/illinois-state-university/og.jpg",
    "title": "Cookhall",
    "author": "William Wesen Appraiser",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACookhall.JPG",
    "read": "2026-10-01"
};

export default photo;
